import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-recupaiement",
  templateUrl: "./recupaiement.component.html",
  styleUrls: ["./recupaiement.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: { class: "ecommerce-application" },
})
export class RecupaiementComponent implements OnInit {
  @Input() public dataService;
  @Input() public nomService;
  dir: boolean = false;
  constructor(public modal: NgbActiveModal, private TranslateModule: TranslateService) {
    switch (this.TranslateModule.currentLang) {
      case "fr":
        this.dir = false;
        break;
      case "en":
        this.dir = false;
        break;
      case "ar":
        this.dir = true;
        break;
      case "tn":
        this.dir = true;
        break;
    }
  }

  ngOnInit(): void {}
}
